import { SVGProps } from 'react';

export const AccordionDownIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 60 60' fill='none' {...props}>
    <path stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' strokeWidth={3} d='m20 25 10 10 10-10' />
  </svg>
);
